export function getParam(name) {
    let match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);

    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

export function getExpiryRecord(value) {
    let expiryPeriod = 90 * 24 * 60 * 60 * 1000; // 90 days on milliseconds
    let expiryDate = new Date().getTime() + expiryPeriod;

    return {
        value: value,
        expiryDate: expiryDate
    };
}

export function setCookie(name, value, days) {
    let date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    let expires = "expires=" + date.toUTCString();

    document.cookie = name + '=' + value + ';' + expires + ';path=/';
}

export function getCookie(name) {
    let cookies = document.cookie.split(';');
    name = name + "=";

    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim();

        if (cookie.indexOf(name) === 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }

    return null;
}

export function getFormattedDate() {
    return new Date().toLocaleDateString(
        'en-CA',
        {
            timeZone: 'America/Sao_Paulo'
        }
    );
}

export function getFormattedTime() {
    return new Date().toTimeString().split(' ')[0]
}